<template>
  <div>
    <n-table :bordered="true" :single-line="false">
      <tbody>
        <tr>
          <td style="width: 60px">序号</td>
          <td>课程名称</td>
          <td>章节名称</td>
          <td>视频名称</td>
          <td style="width: 60px">学时</td>
          <td>获取学时时间</td>
        </tr>
        <tr v-for="(item, index) in data" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.courseName }}</td>
          <td>{{ item.chapterName }}</td>
          <td>{{ item.videoName }}</td>
          <td>{{ item.period }}</td>
          <td>{{ item.signTime }}</td>
        </tr>
      </tbody>
    </n-table>
  </div>
</template>

<script>
import { lessonDetail } from '@/api';
import { ref } from 'vue';
export default {
  props: {
    msgWl: String,
  },
  setup(props, { emit }) {
    // 父组件传的值 props
    console.log(props);
    // 数据
    const data = ref([]);
    lessonDetail({ stuId: props.msgWl, type: '1' }).then(res => {
      data.value = res;
      console.log(res);
    });
    const msg = '网路课学时详情';
    return { msg, data };
  },
};
</script>
